import React from 'react';

import styles from './ProgressBar.module.scss';

function Filler(props) {
	return <div className={styles.filler} style={{ width: `${props.percentage}%` }}></div>;
}

export default Filler;
